module.exports = __webpack_public_path__ + "static/media/info-logo.8067e6bf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-logo.gif
// module id = 1748
// module chunks = 0